import {GroupMark} from '../marks/marktypes';

export default function(role, style, name, dataRef, interactive, encode, marks) {
  return {
    type: GroupMark,
    name: name,
    role: role,
    style: style,
    from: dataRef,
    interactive: interactive,
    encode: encode,
    marks: marks
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/guides/guide-group.js
// module id = 828
// module chunks = 0